<template>
	<div>
		<modaluser :propAdd='paramProp' ref="modalUser" @action="save"/>
		<modalconfirm supplier ref="modalconfirmUser" @action="deleteData"/>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Pengguna</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="grey lighten-3" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-btn dark depressed class="cyan darken-2" @click.stop="tambahUser">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah Pengguna</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn text depressed class="cyan darken-2 mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn class="cyan darken-2" text dark @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<v-col cols="12" class="px-3">
					<v-row>
						<v-col cols="12" md="4">
							<v-text-field outlined dense hide-details label="Nama" v-model="name.value" color="cyan darken-2"></v-text-field>
						</v-col>
						<v-col cols="12" md="4">
							<v-text-field outlined dense hide-details label="No Hp" v-model="phone.value" color="cyan darken-2"></v-text-field>
						</v-col>
						<v-col cols="12" md="4">
							<v-text-field outlined dense hide-details label="Email" v-model="email.value" color="cyan darken-2"></v-text-field>
						</v-col>
						<v-col cols="12" md="4">
							<v-text-field outlined dense hide-details label="Username" v-model="username.value" color="cyan darken-2"></v-text-field>
						</v-col>
						<v-col cols="12" md="4">
							<v-autocomplete class="text-capitalize" outlined dense hide-details v-model="type.value" :items="OptionType" item-text="type_name" item-value="type_name" label="Tipe" color="cyan darken-2" item-color="cyan darken-2" no-data-text="Tidak ada data yang sesuai">
								<template v-slot:item="{item}">
									<div class="text-capitalize">{{item.type_name}}</div>
								</template>
							</v-autocomplete>
						</v-col>
						<v-col cols="12" md="4" class="text-right">
							<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
							<v-btn depressed color="cyan darken-2" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
						</v-col>
					</v-row>
				</v-col>
				<v-card-actions class="px-3" v-if="false">
					<v-spacer></v-spacer>
					<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
					<v-btn depressed color="cyan darken-2" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
				</v-card-actions>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table dense loading disable-pagination :headers="headers" :items="userResults" :search="search" hide-default-footer :options.sync="option" :server-items-length="userPagination.total_data">
				<template v-slot:item.user_supplier_name="{ item }">
					<div class="d-flex">
						<v-avatar color="indigo" size="36">
							<img class="avatar" :src="item.user_supplier_image ? item.user_supplier_image : '/assets/user/profile-pict-menolak-big.png'">
						</v-avatar>
						<div class="pl-2 my-auto">{{ item.user_supplier_name }}</div>
					</div>
				</template>
				<template v-slot:item.contact="{ item }">
					<div class="pt-2">{{ item.user_supplier_mobilephone }}</div>
					<div class="pb-2">{{ item.user_supplier_email }}</div>
				</template>
				<template v-slot:item.active="{ item }">
					<v-switch color="cyan darken-2" v-model="item.user_supplier_is_active" @change="editStatus(item)"></v-switch>
				</template>
				<template v-slot:item.user_supplier_username="{ item }">
					<div class="pt-2">{{ item.user_supplier_username }}</div>
					<div class="pb-2 text-capitalize">{{ item.user_supplier_type }}</div>
				</template>
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="mr-1" fab dark x-small depressed color="teal" v-bind="attrs" v-on="on" @click.stop="editUser(item)">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Edit</span>
					</v-tooltip>
					<v-tooltip bottom v-if="userData.user_supplier_id != item.user_supplier_id">
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="showConfirmation(item.user_supplier_id, item.user_supplier_name)">
								<v-icon dark>mdi-delete</v-icon>
							</v-btn>
						</template>
						<span>Hapus</span>
					</v-tooltip>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!userPagination">
						<loading-data-cyan></loading-data-cyan>
					</div>
					<div class="py-3" v-else>
						<not-found-cyan></not-found-cyan>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="userPagination.total_page > 0 && userResults.length > 0">
			<v-row>
				<v-col cols="10" md="11" class="py-0 d-flex justify-end">
					<v-pagination v-model="page" :length="userPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus" color="cyan darken-2"></v-pagination>
				</v-col>
				<v-col cols="2" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item" color="cyan darken-2" item-color="cyan darken-4"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import modaluser from '@/views/MLsupplier/user/ModalUser'
import {mapActions,  mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
		modaluser
	},
	data() {
		return {
			theactive:[],
			sortBy: 'user_supplier_name',
			sortDir: 'ASC',
			page: 1,
			limit: 10,
			listLimit: [ 5, 10, 20, 50, 100 ],
			paramProp: '',
			propDelete: '',
			val: {},
			edit: 'edit',
			dialog: false,
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Nama', align: 'start', value: 'user_supplier_name'},
			{ text: 'Kontak', value: 'contact', sortable: false},
			{ text: 'Username', value: 'user_supplier_username' },
			{ text: 'Aktif', value: 'active', sortable: false},
			{ text: 'Aksi', value: 'action', sortable: false, },
			],
			username: {
				value:'',
				comparison:'like',
				type:'string',
				field:'user_supplier_username'
			},
			email: {
				value:'',
				comparison:'like',
				type:'string',
				field:'user_supplier_email'
			},
			phone: {
				value:'',
				comparison:'like',
				type:'string',
				field:'user_supplier_mobilephone'
			},
			name: {
				value:'',
				comparison:'like',
				type:'string',
				field:'user_supplier_name'
			},
			type: {
				value:'',
				comparison:'=',
				type:'string',
				field:'user_supplier_type'
			},
			params:[],
			paramStatus : {
				id : '',
				status : ''
			}
		}
	},
	props: {
	},
	computed: {
		...mapState('authSupplier', ['userData']),
		...mapState('userSupplier', ['userResults', 'userPagination', 'OptionType', 'responSukses']),
	},
	methods: {
		...mapActions('userSupplier', ['getDataUser', 'getTypeOption', 'status', 'delete', 'exportUser', 'add', 'update']),
		...mapMutations('userSupplier', ['clearDataUser', 'saveResponse']),
		...mapMutations(['setOverlay']),

		tambahUser() {
			this.paramProp = 'tambah'
			this.$refs.modalUser.show({
				username: '',
				password: '',
				repassword: '',
				name : '',
				email : '',
				mobilephone : '',
			})
		},
		editUser(item) {
			let data = {
				id: item.user_supplier_id,
				name: item.user_supplier_name,
				email: item.user_supplier_email,
				mobilephone: item.user_supplier_mobilephone,
				image: item.user_supplier_image
			}
			this.paramProp = 'edit'
			this.$refs.modalUser.show(data)
		},
		async save(data){
			await this.setOverlay(true)
			if(this.paramProp == 'tambah') {
				await this.add(data).then( () => {
					if(this.responSukses.code == 200) {
						this.getDataUser(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
						this.$refs.modalUser.hide()
						this.saveResponse({})
					}
				})
			} else {
				delete data.image
				await this.update(data).then( () => {
					if(this.responSukses.code == 200) {
						this.getDataUser(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
						this.$refs.modalUser.hide()
						this.saveResponse({})
					}
				})
			}
			await this.setOverlay(false)
		},
		exportData(){
			this.exportUser(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		editStatus(stat){
			this.paramStatus.id = stat.user_supplier_id
			if (stat.user_supplier_is_active== false) {
				this.paramStatus.status = 'inactive'
			} else {
				this.paramStatus.status = 'active'
			}
			this.status(this.paramStatus).then(() => {
				this.getDataUser(this.queryString({limit:this.limit, page: this.page, params:this.params}))
			})
		},
		cari() {
			this.params = []
			if(this.username.value)
				this.params.push(this.username)

			if(this.email.value)
				this.params.push(this.email)

			if(this.phone.value)
				this.params.push(this.phone)

			if(this.name.value)
				this.params.push(this.name)

			if(this.type.value)
				this.params.push(this.type)

			this.getDataUser(this.queryString({limit:this.limit, page: 1, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		resetFilter() {
			this.username.value = ''
			this.email.value = ''
			this.phone.value = ''
			this.name.value = ''
			this.type.value = ''
			this.params = []
			this.limit = 10
			this.getDataUser(this.queryString({limit:this.limit, page: 1, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		showConfirmation(id, name){
			this.propDelete = id
			let msg = `Yakin ingin menghapus ${name}`
			this.$refs.modalconfirmUser.setMessage(msg)
			this.$refs.modalconfirmUser.showConfirm()
		},
		async deleteData() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmUser.hideConfirm()
			await this.delete(this.propDelete).then( () => {
				this.getDataUser(this.queryString({limit:this.limit, page: this.page, params:this.params}))
			})
			await this.setOverlay(false)
		},
	},
	created() {
		this.getDataUser()
		this.getTypeOption()
		this.$store.dispatch('setPageTitle', `User`);
	},
	beforeDestroy(){
		this.clearDataUser()
	},
	watch: {
		page() {
			this.getDataUser(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		limit() {
			this.page = 1
			this.getDataUser(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'DESC' : 'ASC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getDataUser(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		}
	}
}
</script>